
import { Union, Record } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ClientApiResponse$1_$reflection, RequestedValue$1_$reflection, StorageId_$reflection } from "../../Shared/Shared.js";
import { StorageDetailDto_$reflection } from "../../Shared/Storage.js";
import { union_type, class_type, list_type, string_type, record_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class State extends Record {
    constructor(StorageId, Storage) {
        super();
        this.StorageId = StorageId;
        this.Storage = Storage;
    }
}

export function State_$reflection() {
    return record_type("Storage.Detail.Types.State", [], State, () => [["StorageId", StorageId_$reflection()], ["Storage", RequestedValue$1_$reflection(StorageDetailDto_$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DeleteStorage", "AssignQrCode", "RemoveQrCodes", "QRCodeRequestFinished", "FetchStorage", "StorageFetched", "StorageDeleted", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Storage.Detail.Types.Msg", [], Msg, () => [[], [["Item", string_type]], [["Item", list_type(string_type)]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", StorageDetailDto_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

